import { AssetsParams, GetAssetsResponse } from '../types';
import { baseClient } from './client/instance';

const path = 'assets';

export const getAssets = async (params?: AssetsParams) => {
  const response = await baseClient.get<GetAssetsResponse>(path, { params });
  return response.data;
};
